import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  BetNotificationWr,
  SlowConnectionWr,
  UnderMaintenanceWr,
  applicationStore,
  useTranslation,
} from '@pascal/pascal-core';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';
import { BettingPart } from '../../containers/common/bettingPart';
import { GamePartWrapper } from '../../components/common/gamePart';
import { gameStore } from '../../store';
import { minOddConstant } from '../../enums/gameConstants';

export const GameMain = observer(() => {
  const t = useTranslation();
  const {
    activeFreeBet: { minOdd },
  } = freeBetStore;
  const { partnerWageringOdd } = gameStore;
  const dynamicMinOdd = applicationStore.isDemo
    ? minOddConstant
    : minOdd || partnerWageringOdd || minOddConstant;
  return (
    <div className='game-center-wr'>
      <BetNotificationWr autoCashOutMinOdd={dynamicMinOdd} />
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <GamePartWrapper t={t} />
      <BettingPart t={t} />
    </div>
  );
});
/* todo <FreeBetMaxPayoutPopUp /> */
